module.exports = __webpack_public_path__ + "fonts/IndivisibleWebBold.5f959547.woff";